const pt_br = {
    values: {
        'Settings successfully saved': 'Configurações salvas com sucesso',
        'There was an error saving the eventbased clock settings': 'Houve um erro ao salvar as configurações do eventbased clock',
        'Emit full rejected events': 'Gerar eventos de rejeição completos',
        'Defines if the full eventbasedclock_event_rejected are emitted. When false we will have only the aggregated.': 'Define se eventos "eventbasedclock_event_rejected" são emitidos com dados completos em cada ocorrência. Quando falso teremos apenas eventos agregados.',
        'Persist full rejected events': 'Persistir eventos de rejeição',
        'If false the events are created with __skipstorage:true (i.e. only available in realtime but not saved in Live storage)': ' Se falso, os eventos "eventbasedclock_event_rejected" são criados com __skipstorage:true (ou seja, disponíveis apenas em tempo real, mas não salvos no armazenamento do Live)',
        'Event-based clock settings': 'Configurações do event-based clock'

    }
}

export default pt_br